// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"1613de0c","367":"b78fe88f","552":"348b0e44","705":"ad84a90b","769":"1a1dd287"}[chunkId] + ".chunk.css";
};